import React from 'react';
import './styles.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import CareImage from 'assets/about-us/values/Care.png';
import DelightersImage from 'assets/about-us/values/Delighters.png';
import RestlessImage from 'assets/about-us/values/Restless.png';
import PassionateImage from 'assets/about-us/values/Passionate.png';
import FairImage from 'assets/about-us/values/Fair.png';

const AboutUsUbianValuesSection = () => {
  return (
    <div className="__AboutUsUbianValuesSection __my-container-v2 font_lato">
      <h4 className="__primary-text-color font_montserrat font-weight-mediam-bold text-center __title">Urbain's Values</h4>
      <div className="__main">
        <div className="__value-section d-flex">
          <div>
            <LazyLoadImage src={CareImage} alt={'Care'} className="value-image" />
            <h5 className="__primary-text-color font_montserrat font-weight-mediam-bold m-0">Care</h5>
            <p className="__blog-section">
              We care about our customers. We care about our owners. We care about the local areas our properties are in.
            </p>
          </div>
        </div>
        <div className="__value-section d-flex">
          <div>
            <LazyLoadImage src={DelightersImage} alt={'Delighters'} className="value-image" />
            <h5 className="__primary-text-color font_montserrat font-weight-mediam-bold m-0">Delighters</h5>
            <p className="__blog-section">We will always go the extra mile to give our guests the most delightful experience during their stay.</p>
          </div>
        </div>
        <div className="__value-section d-flex">
          <div>
            <LazyLoadImage src={RestlessImage} alt={'Restless'} className="value-image" />
            <h5 className="__primary-text-color font_montserrat font-weight-mediam-bold m-0">Restless</h5>
            <p className="__blog-section">
              We are re-defining the urban STR category. Ever curious about finding the perfect locations, creature comforts, best facilities,
              improving the search and booking process. We will work tirelessly to ensure we keep making things even better.
            </p>
          </div>
        </div>
        <div className="__value-section d-flex">
          <div>
            <LazyLoadImage src={PassionateImage} alt={'Passionate'} className="value-image" />
            <h5 className="__primary-text-color font_montserrat font-weight-mediam-bold m-0">Passionate</h5>
            <p className="__blog-section">
              We are passionate (almost to the level of obsession) about travel and about providing the best and most delightful travel experiences.
            </p>
          </div>
        </div>
        <div className="__value-section d-flex">
          <div>
            <LazyLoadImage src={FairImage} alt={'Fair'} className="value-image" />
            <h5 className="__primary-text-color font_montserrat font-weight-mediam-bold m-0">Fair</h5>
            <p className="__blog-section">
              We do right by everyone we work with; we are open and honest, we have favourable terms, we keep things simple, there are no tricksy
              contracts or hidden extras.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsUbianValuesSection;
